export default __webpack_public_path__ + "static/media/9dedb156a2abb97cb1ab88048472e8f1.md";